import { logger } from 'packages';
//jshint module : true
import myTradera from './my-tradera';
import ENDPOINTS from 'tradera-constants/endpoints';
import { removePayout } from '../payouts/reducer';
import { selectPaymentsState } from 'tradera-apps/my-tradera/app/state/reducers/payments-reducer';
const actionTypes = {
    // Init
    INIT_DATA_LOAD: 'INIT_DATA_LOAD',
    INIT_DATA_LOADED: 'INIT_DATA_LOADED',

    // Swish
    UPDATE_PHONENUMBER: 'UPDATE_PHONENUMBER',
    INVALID_PHONENUMBER: 'INVALID_PHONENUMBER',
    UPDATE_VERIFYCODE: 'UPDATE_VERIFYCODE',
    INVALID_VERIFYCODE: 'INVALID_VERIFYCODE',
    DELETE_PHONENUMBER: 'DELETE_PHONENUMBER',
    SAVE_PHONENUMBER: 'SAVE_PHONENUMBER',
    SWISH_ENABLED: 'SWISH_ENABLED',
    SWISH_ERROR: 'SWISH_ERROR',

    // Bank
    DELETE_BANK_ACCOUNT: 'DELETE_BANK_ACCOUNT',
    UPDATE_CLEARING_NUMBER: 'UPDATE_CLEARING_NUMBER',
    UPDATE_ACCOUNT_NUMBER: 'UPDATE_ACCOUNT_NUMBER',
    BANK_NOT_MATCHED: 'BANK_NOT_MATCHED',
    IGNORE_BANK_NOT_MATCHED: 'IGNORE_BANK_NOT_MATCHED',
    BANK_ACCOUNT_SAVED: 'BANK_ACCOUNT_SAVED',
    INVALID_CLEARINGNUMBER: 'INVALID_CLEARINGNUMBER',
    INVALID_BANKACCOUNTNUMBER: 'INVALID_BANKACCOUNTNUMBER',
    BANK_ERROR: 'BANK_ERROR',

    // Tink
    INIT_TINK: 'INIT_TINK',
    CANCEL_TINK: 'CANCEL_TINK',
    SHOW_BANK_ACCOUNTS: 'SHOW_BANK_ACCOUNTS',
    SELECT_BANK_ACCOUNT: 'SELECT_BANK_ACCOUNT',
    TINK_COMPLETED: 'TINK_COMPLETED',
    TINK_ERROR: 'TINK_ERROR',

    // BankId
    SKIP_BANKID_AUTH: 'SKIP_BANKID_AUTH',
    BEGIN_BANKID_AUTH: 'BEGIN_BANKID_AUTH',
    CANCEL_BANKID_AUTH: 'CANCEL_BANKID_AUTH',
    BANKID_IN_PROGRESS: 'BANKID_IN_PROGRESS',
    BANKID_COMPLETED: 'BANKID_COMPLETED',
    BANKID_ERROR: 'BANKID_ERROR',

    // Payouts
    PAYOUTS_LOADED: 'PAYOUTS_LOADED',
    PAYOUTS_ERROR: 'PAYOUTS_ERROR'
};

// Init

const loadInitData = toLocalizedUrl => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.INIT_DATA_LOAD });
            const response = await fetch(
                toLocalizedUrl('/my/payments2/GetInitData'),
                {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            const result = await response.json();
            if (response.ok)
                dispatch({
                    type: actionTypes.INIT_DATA_LOADED,
                    payload: result
                });
            else
                dispatch({
                    type: actionTypes.PAYOUTS_ERROR,
                    payload: 'Det gick inte att ladda utbetalningar.'
                });

            dispatch(myTradera.searching(false));
            dispatch(myTradera.error(false));
        } catch (err) {
            logger(err);
        }
    };
};

// Swish

const updatePhoneNumber = newNumber => ({
    type: actionTypes.UPDATE_PHONENUMBER,
    payload: { number: newNumber, isValid: newNumber.length > 7 }
});

const updateVerifyCode = verifyCode => ({
    type: actionTypes.UPDATE_VERIFYCODE,
    payload: verifyCode
});

const deletePhoneNumber = () => {
    return async dispatch => {
        try {
            const response = await fetch('/my/payments2/DeletePhoneNumber', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' }
            });
            await response.json();
            if (response.ok) dispatch({ type: actionTypes.DELETE_PHONENUMBER });
            else
                dispatch({
                    type: actionTypes.SWISH_ERROR,
                    payload: 'Ett fel uppstod. Försök igen.'
                });
        } catch (err) {
            logger(err);
            dispatch({
                type: actionTypes.SWISH_ERROR,
                payload: 'Ett fel uppstod. Försök igen.'
            });
        }
    };
};

const verifyCode = code => {
    return async dispatch => {
        try {
            const response = await fetch('/my/payments2/VerifyCode', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code: code })
            });
            const result = await response.json();
            const payload = {
                type: 'swish',
                completeText: 'Ditt Swish-nummer är nu tillagt och bekräftat.',
                verificationText: 'Bekräfta Swish-nummer'
            };
            if (response.ok) {
                dispatch({
                    type: actionTypes.BEGIN_BANKID_AUTH,
                    payload: payload
                });
                dispatch(bankIdAuthenticate());
            } else if (result.code == 'InvalidCode')
                dispatch({
                    type: actionTypes.INVALID_VERIFYCODE,
                    payload: 'Du har angett fel kod.'
                });
            else
                dispatch({
                    type: actionTypes.SWISH_ERROR,
                    payload: 'Ett fel uppstod. Försök igen.'
                });
        } catch (err) {
            logger(err);
            dispatch({
                type: actionTypes.SWISH_ERROR,
                payload: 'Ett fel uppstod. Försök igen.'
            });
        }
    };
};

const savePhoneNumber = newNumber => {
    return async dispatch => {
        try {
            const response = await fetch('/my/payments2/SavePhoneNumber', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ phoneNumber: newNumber })
            });
            const result = await response.json();
            if (
                response.ok &&
                !result.requireSmsVerification &&
                !result.requireBankIdVerification
            ) {
                const payload = {
                    type: 'swish',
                    completeText:
                        'Ditt Swish-nummer är nu tillagt och bekräftat.',
                    verificationText: 'Bekräfta Swish-nummer'
                };
                dispatch({
                    type: actionTypes.SAVE_PHONENUMBER,
                    payload: newNumber
                });
                dispatch({ type: actionTypes.SWISH_ENABLED });
                dispatch({
                    type: actionTypes.SKIP_BANKID_AUTH,
                    payload: payload
                });
            } else if (response.ok)
                dispatch({
                    type: actionTypes.SAVE_PHONENUMBER,
                    payload: newNumber
                });
            else if (result.code == 'InvalidPhoneNumber')
                dispatch({
                    type: actionTypes.INVALID_PHONENUMBER,
                    payload: 'Du har angett ett felaktigt telefonnummer.'
                });
            else if (result.code == 'InvalidCompanySwishNumber')
                dispatch({
                    type: actionTypes.INVALID_PHONENUMBER,
                    payload: 'Du har angett ett felaktigt Swishnummer.'
                });
            else if (result.code == 'SendSmsError')
                dispatch({
                    type: actionTypes.SWISH_ERROR,
                    payload: 'Det gick inte att skicka SMS. Försök igen.'
                });
            else
                dispatch({
                    type: actionTypes.SWISH_ERROR,
                    payload: 'Ett fel uppstod. Försök igen.'
                });
        } catch (err) {
            logger(err);
            dispatch({
                type: actionTypes.SWISH_ERROR,
                payload: 'Ett fel uppstod. Försök igen.'
            });
        }
    };
};

const setVerifiedPhoneNumber = () => {
    return async dispatch => {
        try {
            const response = await fetch('/my/payments2/SetSwishVerified', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' }
            });
            await response.json();
            if (response.ok) dispatch({ type: actionTypes.SWISH_ENABLED });
            else
                dispatch({
                    type: actionTypes.SWISH_ERROR,
                    payload: 'Ett fel uppstod. Försök igen.'
                });
        } catch (err) {
            logger(err);
            dispatch({
                type: actionTypes.SWISH_ERROR,
                payload: 'Ett fel uppstod. Försök igen.'
            });
        }
    };
};

// Bank

const updateAccountNumber = newAccountNumber => ({
    type: actionTypes.UPDATE_ACCOUNT_NUMBER,
    payload: {
        newAccountNumber: newAccountNumber,
        isValid: newAccountNumber.length > 4
    }
});

const updateClearingNumber = newClearingNumber => ({
    type: actionTypes.UPDATE_CLEARING_NUMBER,
    payload: {
        newClearingNumber: newClearingNumber,
        isValid: newClearingNumber.length > 3
    }
});

const deleteBankAccount = () => {
    return async dispatch => {
        try {
            const response = await fetch('/my/payments2/DeleteBankAccount', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                dispatch({ type: actionTypes.DELETE_BANK_ACCOUNT });
                dispatch(removePayout());
            } else {
                dispatch({
                    type: actionTypes.BANK_ERROR,
                    payload: 'Ett fel uppstod. Försök igen.'
                });
            }
        } catch (err) {
            logger(err);
            dispatch({
                type: actionTypes.BANK_ERROR,
                payload: 'Ett fel uppstod. Försök igen.'
            });
        }
    };
};

const saveBankAccount = () => {
    return async (dispatch, getState) => {
        try {
            const clearingNumber = selectPaymentsState(getState())
                .bankAccountDetails.newClearingNumber;
            const accountNumber = selectPaymentsState(getState())
                .bankAccountDetails.newAccountNumber;
            const response = await fetch('/my/payments2/SaveBankAccount', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    clearingNumber: clearingNumber,
                    accountNumber: accountNumber
                })
            });
            const result = await response.json();
            if (response.ok) {
                dispatch({
                    type: actionTypes.BANK_ACCOUNT_SAVED,
                    payload: result.maskedAccountNumber
                });
            } else if (result.code == 'InvalidClearingNumber') {
                dispatch({
                    type: actionTypes.INVALID_CLEARINGNUMBER,
                    payload:
                        'Du har angett ett felaktigt clearingnummer. Clearingnumret ska vara 4-5 siffror långt.'
                });
            } else if (result.code == 'InvalidBankAccountNumber') {
                dispatch({
                    type: actionTypes.INVALID_BANKACCOUNTNUMBER,
                    payload:
                        'Du har angett ett felaktigt bankkontonummer. Bankkontonumret ska vara mellan 7-10 siffror långt.'
                });
            } else {
                dispatch({
                    type: actionTypes.BANK_ERROR,
                    payload: 'Ett fel uppstod. Försök igen.'
                });
            }
        } catch (err) {
            logger(err);
            dispatch({
                type: actionTypes.BANK_ERROR,
                payload: 'Ett fel uppstod. Försök igen.'
            });
        }
    };
};

const initSaveBankAccount = () => {
    return async (dispatch, getState) => {
        try {
            const clearingNumber = selectPaymentsState(getState())
                .bankAccountDetails.newClearingNumber;
            const accountNumber = selectPaymentsState(getState())
                .bankAccountDetails.newAccountNumber;

            const response = await fetch('/my/payments2/MatchBank', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    clearingNumber: clearingNumber,
                    accountNumber: accountNumber
                })
            });

            const result = await response.json();

            if (result.invalidNumber) {
                dispatch({
                    type: actionTypes.BANK_ERROR,
                    payload: 'Felaktigt kontonummer'
                });
                return;
            }
            const payload = {
                type: 'bank',
                completeText: 'Ditt bankkonto är nu tillagt och bekräftat.',
                verificationText: 'Bekräfta bankkonto'
            };
            if (result.ok && !result.requireBankIdVerification) {
                dispatch(saveBankAccount());
                dispatch({
                    type: actionTypes.SKIP_BANKID_AUTH,
                    payload: payload
                });
                return;
            }
            if (result.ok) {
                dispatch({
                    type: actionTypes.BEGIN_BANKID_AUTH,
                    payload: payload
                });
                dispatch(bankIdAuthenticate());
                return;
            }

            dispatch({ type: actionTypes.BANK_NOT_MATCHED });
            if (result.requireBankIdVerification) {
                dispatch({
                    type: actionTypes.BEGIN_BANKID_AUTH,
                    payload: payload
                });
            } else {
                dispatch({
                    type: actionTypes.SKIP_BANKID_AUTH,
                    payload: payload
                });
            }
        } catch (err) {
            logger(err);
            dispatch({
                type: actionTypes.BANK_ERROR,
                payload: 'Ett fel uppstod. Försök igen.'
            });
        }
    };
};

// Tink
const initTink = () => ({
    type: actionTypes.INIT_TINK
});

const cancelTink = () => ({
    type: actionTypes.CANCEL_TINK
});

const errorTink = () => ({
    type: actionTypes.TINK_ERROR,
    payload: 'Ett fel uppstod. Försök igen.'
});

const loadBankAccounts = data => {
    return async dispatch => {
        try {
            const response = await fetch(
                '/my/payments2/TinkCallback?code=' + data.data,
                {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            const result = await response.json();
            dispatch({
                type: actionTypes.SHOW_BANK_ACCOUNTS,
                payload: result.accounts
            });
        } catch (err) {
            logger(err);
            dispatch({
                type: actionTypes.TINK_ERROR,
                payload: 'Ett fel uppstod. Försök igen.'
            });
        }
    };
};

const selectBankAccount = account => {
    return async dispatch => {
        dispatch({ type: actionTypes.SELECT_BANK_ACCOUNT, payload: account });
        const payload = {
            type: 'tink',
            completeText: 'Ditt bankkonto är nu tillagt och bekräftat.',
            verificationText: 'Bekräfta bankkonto'
        };
        dispatch({ type: actionTypes.BEGIN_BANKID_AUTH, payload: payload });
    };
};

// Needs better handling: 500 error on fetch does not catch
const saveTinkBankAccount = account => {
    return async dispatch => {
        try {
            const response = await fetch('/my/payments2/SaveTinkBankAccount', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ accountNumber: account.accountNumber })
            });
            const result = await response.json();
            if (result.errorMessage) {
                dispatch({
                    type: actionTypes.TINK_ERROR,
                    payload: result.errorMessage
                });
            } else {
                dispatch({
                    type: actionTypes.TINK_COMPLETED,
                    payload: result.maskedAccountNumber
                });
            }
        } catch (err) {
            logger(err);
            dispatch({
                type: actionTypes.TINK_ERROR,
                payload: 'Ett fel uppstod. Försök igen.'
            });
        }
    };
};

// BankId

const cancelBankId = () => {
    return async dispatch => {
        try {
            await fetch('/bankid/cancel', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' }
            });
        } catch (err) {
            logger(err);
        }

        dispatch({ type: actionTypes.CANCEL_BANKID_AUTH });
    };
};

const bankIdContinue = () => {
    return async (dispatch, getState) => {
        dispatch({ type: actionTypes.IGNORE_BANK_NOT_MATCHED });
        if (
            selectPaymentsState(getState()).bankIdVerification
                .requireBankIdVerification
        ) {
            dispatch(bankIdAuthenticate());
        } else {
            dispatch(saveBankAccount());
        }
    };
};

const bankIdAuthenticate = () => {
    return async (dispatch, getState) => {
        try {
            const response = await fetch(ENDPOINTS.BANK_ID_AUTHENTICATE, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    purpose: 'confirm-bank-account-or-swish'
                })
            });

            const result = await response.json();
            if (result.errorMessage) {
                dispatch({
                    type: actionTypes.BANKID_ERROR,
                    payload: bankIdUserMessage(result.errorMessage)
                });
                return;
            }
            dispatch({ type: actionTypes.BANKID_IN_PROGRESS, payload: result });

            selectPaymentsState(getState()).bankIdVerification.errorCount = 0;

            dispatch(bankIdPollProgress());
        } catch (err) {
            logger(err);
            dispatch({
                type: actionTypes.BANKID_ERROR,
                payload: 'Ett fel uppstod. Försök igen.'
            });
        }
    };
};

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const bankIdPollProgress = () => {
    return async (dispatch, getState) => {
        try {
            const response = await fetch(
                `${ENDPOINTS.BANK_ID_PROGRESS}?${new Date().getTime()}`,
                {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            const result = await response.json();
            if (result.errorMessage) {
                dispatch({
                    type: actionTypes.BANKID_ERROR,
                    payload: bankIdUserMessage(result.errorMessage)
                });
                return;
            }
            if (result.isCompleted) {
                if (
                    selectPaymentsState(getState()).bankIdVerification.type ===
                    'swish'
                ) {
                    dispatch(setVerifiedPhoneNumber());
                } else if (
                    selectPaymentsState(getState()).bankIdVerification.type ===
                    'bank'
                ) {
                    dispatch(saveBankAccount());
                } else if (
                    selectPaymentsState(getState()).bankIdVerification.type ===
                    'tink'
                ) {
                    dispatch(
                        saveTinkBankAccount(
                            selectPaymentsState(getState()).tink.account
                        )
                    );
                }
                dispatch({ type: actionTypes.BANKID_COMPLETED });
                return;
            }
            await sleep(3000);
            if (
                !selectPaymentsState(getState()).bankIdVerification
                    .bankIdInProgress
            ) {
                return;
            }
            dispatch(bankIdPollProgress());
        } catch (err) {
            selectPaymentsState(getState()).bankIdVerification.errorCount++;
            if (
                selectPaymentsState(getState()).bankIdVerification.errorCount <
                3
            ) {
                dispatch(bankIdPollProgress());
            } else {
                logger(err);
                dispatch({
                    type: actionTypes.BANKID_ERROR,
                    payload: 'Ett fel uppstod. Försök igen.'
                });
            }
        }
    };
};

const bankIdUserMessage = errorMessage => {
    switch (errorMessage) {
        case 'START_FAILED':
            return 'BankID-appen verkar inte finnas i din dator eller telefon. Installera den och hämta ett BankID hos din internetbank.';
        case 'EXPIRED_TRANSACTION':
            return 'BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. Om du inte har något giltigt BankID kan du hämta ett hos din Bank. Försök sedan igen.';
        case 'ALREADY_IN_PROGRESS':
            return 'En identifiering för det här personnumret är redan påbörjad. Vänta en stund och försök igen.';
        case 'CERTIFICATE_ERROR':
            return 'Det BankID du försöker använda är för gammalt eller spärrat. Använd ett annat BankID eller hämta ett nytt hos din internetbank.';
        case 'CANCELLED':
            return 'Åtgärden avbruten. Försök igen.';
        case 'USER_CANCEL':
            return 'Åtgärden avbruten.';
        default:
            return 'Ett fel uppstod. Försök igen.';
    }
};

// Payouts
const loadPayouts = (toLocalizedUrl, page) => {
    return async dispatch => {
        var params = page ? '?page=' + page : '';
        try {
            const response = await fetch(
                toLocalizedUrl('/my/payments2/payouts' + params),
                {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            const result = await response.json();
            if (response.ok)
                dispatch({ type: actionTypes.PAYOUTS_LOADED, payload: result });
            else
                dispatch({
                    type: actionTypes.PAYOUTS_ERROR,
                    payload: 'Det gick inte att ladda utbetalningar.'
                });
        } catch (err) {
            logger(err);
        }
    };
};

export default {
    actionTypes,
    loadInitData,
    deletePhoneNumber,
    updatePhoneNumber,
    savePhoneNumber,
    updateVerifyCode,
    verifyCode,
    deleteBankAccount,
    updateAccountNumber,
    updateClearingNumber,
    initSaveBankAccount,
    initTink,
    cancelTink,
    errorTink,
    loadBankAccounts,
    selectBankAccount,
    saveTinkBankAccount,
    cancelBankId,
    bankIdContinue,
    bankIdAuthenticate,
    loadPayouts
};
